import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.equineSnow /* formally a cream color */,
  fontColor: colors.equineIron,
  textColorDark: colors.equineIron,
  textColorLight: colors.equineSnow,
  lastParagraphBottomMargin: '30px'
};
export default promoBanner;